(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-size-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    let kiwiPromise;
    const loadKiwi = (shop) => {
      if (window.ks && typeof window.ks.loadSizing === 'function') return Promise.resolve(window.ks);
      if (kiwiPromise) return kiwiPromise;
      kiwiPromise = new Promise((resolve, reject) => {
        window.KiwiSizing = window.KiwiSizing || { shop };
        let script = document.querySelector('script[src*="SizingPlugin.prod.js"]');
        const started = Date.now();
        const timer = setInterval(() => {
          if (window.ks && typeof window.ks.loadSizing === 'function') {
            clearInterval(timer);
            resolve(window.ks);
          } else if (Date.now() - started > 15000) {
            clearInterval(timer);
            reject(new Error('Size guide unavailable'));
          }
        }, 100);
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://cdn.static.kiwisizing.com/SizingPlugin.prod.js';
          script.async = true;
          script.addEventListener('error', () => { clearInterval(timer); reject(new Error('Size guide unavailable')); }, { once: true });
          document.head.appendChild(script);
        }
      }).catch((error) => { kiwiPromise = undefined; throw error; });
      return kiwiPromise;
    };
    let request = 0;
    let trigger;
    let activeTimer;
    let initialized;
    const initialize = () => {
      const dialog = document.getElementById('gap-cart-size-dialog');
      if (!dialog || dialog === initialized) return dialog;
      initialized = dialog;
      dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-size-close]') || event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        request += 1;
        clearTimeout(activeTimer);
        if (trigger && trigger.isConnected) trigger.focus();
      });
      return dialog;
    };
    document.addEventListener('gap:cart-size-guide', async (event) => {
      const item = event.detail && event.detail.item;
      const dialog = initialize();
      if (!dialog || !item || !item.size_guide_data) return;
      const current = ++request;
      trigger = event.detail.trigger;
      clearTimeout(activeTimer);
      const loading = dialog.querySelector('[data-size-loading]');
      const error = dialog.querySelector('[data-size-error]');
      const host = dialog.querySelector('[data-size-content]');
      const content = document.createElement('div');
      host.replaceChildren(content);
      loading.hidden = false;
      error.hidden = true;
      dialog.querySelector('[data-size-product]').textContent = item.product_title;
      const url = new URL(item.product_url || item.url, window.location.origin);
      dialog.querySelector('[data-size-product-link]').href = url.origin === window.location.origin ? url.href : '/';
      if (!dialog.open) dialog.showModal();
      const fail = () => {
        if (current !== request) return;
        loading.hidden = true;
        error.hidden = true;
        if (content.textContent.trim() || content.querySelector('table,iframe,img')) return;
        error.hidden = false;
      };
      activeTimer = setTimeout(fail, 20000);
      try {
        const ks = await loadKiwi(dialog.dataset.shop);
        if (current !== request) return;
        ks.setShopID(dialog.dataset.shop);
        ks.loadSizing({
          productData: item.size_guide_data,
          options: { el: content, displayMode: 0 },
          loaded: (success) => {
            if (current !== request) return;
            clearTimeout(activeTimer);
            loading.hidden = true;
            error.hidden = Boolean(success);
          }
        });
      } catch (error) {
        clearTimeout(activeTimer);
        fail();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dads-weekend-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!window.dadsWeekendCarouselNavigation) {
    window.dadsWeekendCarouselNavigation = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-dads-carousel-prev], [data-dads-carousel-next]');

      if (!button) return;

      const carousel = button.closest('card-carousel');
      const swiper = carousel?.querySelector('[data-carousel]')?.swiper;

      if (!swiper) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.matches('[data-dads-carousel-next]')) {
        swiper.slideNext();
      } else {
        swiper.slidePrev();
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
